import { ROUTES } from '@/constants'

import { User } from '../../types/auth'
import { canAccessAnalytics, canAccessBilling } from './userPermissions'

const GATED_CABINET_ROUTES = [
	{ url: ROUTES.cabinet.analytics, canAccess: canAccessAnalytics },
	{ url: ROUTES.cabinet.billing, canAccess: canAccessBilling },
]

export const isStatusRestricted = (user: User | null) =>
	!!user && GATED_CABINET_ROUTES.some(({ canAccess }) => !canAccess(user))

export const getGatedRedirectUrl = (user: User | null, targetUrl: string) => {
	if (!user) {
		return null
	}

	const isGated = GATED_CABINET_ROUTES.some(
		({ url, canAccess }) => url === targetUrl && !canAccess(user),
	)

	return isGated ? ROUTES.cabinet.statusRestrictedQrCodes : null
}
